/**
 * 获取schema请求url
 */
export const GET_SCHEMA_URL = '/v1/schema';
